import { create } from 'zustand';
import { NOT_INPUT } from '@/app/_contants';
import { persist } from 'zustand/middleware';

export interface UserInfo {
  userName: string;
  position: string;
  company: string;
  privateAgreementSelect: boolean;
}

interface ExtendedUserInfo extends UserInfo {
  email: string;
  regDate: string;
}

interface ProfileType {
  name: string;
  position: string;
  company: string;
  privateAgreementSelect: boolean;
}

interface AccountStore {
  userInfo: ExtendedUserInfo;
  setExtendedUserInfo: (email: string, regDate: string) => void;
  setProfile: ({ name, position, company, privateAgreementSelect }: ProfileType) => void;
}

const useAccountStore = create(
  persist<AccountStore>(
    (set) => ({
      userInfo: {
        email: '',
        userName: NOT_INPUT,
        position: NOT_INPUT,
        company: NOT_INPUT,
        regDate: '',
        privateAgreementSelect: false,
      },

      setExtendedUserInfo : (email: string, regDate: string) =>
        set((state) => ({
          userInfo: {
            ...state.userInfo,
            email: email,
            regDate: regDate,
          },
        })),

      setProfile: ({ name, position, company, privateAgreementSelect }: ProfileType) =>
        set((state) => ({
          userInfo: {
            ...state.userInfo,
            userName: name || NOT_INPUT,
            position: position || NOT_INPUT,
            company: company || NOT_INPUT,
            privateAgreementSelect,
          },
        })),
    }),
    {
      name: 'account-storage',
    },
  ),
);

export default useAccountStore;
